import theme from "./theme";
import { Box } from "@mui/system";
import { CircularProgress } from "@mui/material";

export default function LoadingCircle({ size = 80 }) {
    return (
        <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
            <CircularProgress sx={{ color: theme.colors.purple }} thickness={4.5} size={size} />
        </Box>
    );
}